<template>
  <div>
    <el-form-item :label="field.name + '：'">
      <div class="up-layout">
        <el-upload
          class="upload-demo"
          ref="upload"
          action="https://yytools-api.mockuai.com/api/test/excel/upload"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :on-success="excelSuccess"
          :on-progress="starUpload"
          :show-file-list="false"
          :limit="limitUpload"
          :auto-upload="true"
        >
          <el-button size="small" type="primary" :loading="loading">{{
            loading ? "正在上传" : "导入excel"
          }}</el-button>
          <div slot="tip" class="el-upload__tip">最多上传50条数据</div>
        </el-upload>
        <div>
          <a
            :href="field.link_down"
            >下载模板</a
          >
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "tms-type-upload-data",
  props: {
    field: {
      type: [Object, Array],
      required: true
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      limitUpload: 1,
      fileTemp: null,
      loading: false
    };
  },
  mounted() {
    console.log(this.config);
  },
  methods: {
    handleChange(file, fileList) {
      this.fileTemp = file.raw;
    },

    handleRemove(file, fileList) {
      this.fileTemp = null;
    },
    starUpload() {
      this.loading = true;
    },
    excelSuccess(res) {
      if (res.data && res.data.length) {
        const list = [];
        res.data.forEach(item => {
          list.push(item);
        });
        if (list.length >= 50) {
          this.loading = false;
          this.$refs.upload.clearFiles();
          this.$message.error("最多添加50个!");
          return;
        }

        this.$set(this.config, this.field.key, this.field.format(list));
      }
      this.$refs.upload.clearFiles();
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.up-layout{
  display: flex;
}
</style>
